import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MyHttpClient } from '../http-client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedeemService {
  private rulesUrl = environment.server + '/api/redeem/rules';
  private ruleUrl = environment.server + '/api/redeem/rule';

  constructor(private http: MyHttpClient) { }

  // Mirrors the legacy fetchAll call: a flat query-param object
  // (active, limit, offset, sort, <field>__in / <field>__regex) forwarded as-is.
  getRules(queryParams: { [key: string]: any }) {
    const qs = Object.keys(queryParams || {})
      .filter(key => queryParams[key] !== undefined && queryParams[key] !== null && queryParams[key] !== '')
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
      .join('&');
    const url = qs ? `${this.rulesUrl}?${qs}` : this.rulesUrl;
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  getRule(ruleId: string) {
    return this.http.get(`${this.ruleUrl}/${ruleId}`).pipe(catchError(this.handleError));
  }

  createRule(rule: any) {
    return this.http.post(this.ruleUrl, rule).pipe(catchError(this.handleError));
  }

  // Full edit and activate/deactivate (via the `active` field) both go through editRule.
  updateRule(ruleId: string, rule: any) {
    return this.http.patch(`${this.ruleUrl}/${ruleId}`, rule).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, body was:`, error.error);
    }
    return throwError(error);
  }
}
